import axios from '@/utils/api'
import Crezu from '@/utils/'
import { useWeightSplitter } from '@/utils/offersWeightsSplitter'
import { openLink } from './redirect-actions'
// import Vue from 'vue'

export const getOffers = function ({ commit, state }) {
  let countryLeadId = state.config.params.countryLeadId || '10c46b96149949849d5acfcb76a30a84'
  let offersConfig = state.config.params.offersConfig || 'MX-new'
  axios({
    method: 'GET',
    url: `https://sl.crezu.net/sl-feed?lead_id=${countryLeadId}&filter=picker`,
    headers: { 'Content-Type': 'application/json' }
  }).then((response) => {
    axios({
      method: 'GET',
      url: `https://cdn.crezu.net/native/feed_lenders/${offersConfig}.json`,
      headers: { 'Content-Type': 'application/json' }
    }).then((response2) => {
      let result = []
      for (let i in response.data) {
        for (let j in response2.data) {
          if (response.data[i] === response2.data[j].name) {
            result.push(response2.data[j])
          }
        }
      }
      commit('ADD_OFFERS', result)
    })
  })
}

export const updateNONAPI = function ({ commit, state }) {
  console.log('get offers with this lead_id:', state.additionalParams.lead_id)
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: `https://sl.crezu.net/sl-feed?lead_id=${state.additionalParams.lead_id}`,
      headers: { 'Content-Type': 'application/json' }
    }).then((response) => {
      if (response.data.length) {
        const result = []
        for (let i in response.data) {
          for (let j in state.offers) {
            if (response.data[i] === state.offers[j].name) result.push(state.offers[j])
          }
        }
        commit('ADD_OFFERS', result)
        resolve(response.data)
      } else {
        reject(new Error('empty list'))
      }
    })
  })
}

export const offersLinking = function ({ commit, state, getters, dispatch }) {
  console.log('offers linking:', state.offers)
  for (let i in state.offers) {
    let offerId = Crezu.common.getURLParameter('offer_id', state.offers[i].link)
    let formData = new FormData()
    formData.set('lead_id', state.additionalParams.lead_id)
    formData.set('offer_id', offerId)
    formData.set('status', ((state.selectedOffers.indexOf(offerId) > -1) ? '0' : '1'))
    axios({
      method: 'POST',
      url: `${state.backendUrl}/webview/lead`,
      data: formData,
      headers: { 'Content-Type': 'application/json' }
    }).then((response) => {
    }, (error) => {
      console.log(error)
    })
  }
}

export const getAvailableAPILenders = function ({ commit, state }, params) {
  // commit('CHANGE_PRELOADER', true)
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: `${state.backendUrl}/lender?lead_id=${state.additionalParams.lead_id}`,
      headers: { 'Content-Type': 'application/json' }
    }).then((response) => {
      console.log('success', response.data)
      resolve(response.data)
    }, (error) => {
      reject(error)
      console.log(error)
    })
  })
}

export const goToOffers = function ({ commit, state, dispatch }, res) {
  const leadId = state.additionalParams.lead_id.split('-').join('') || localStorage.getItem('leadId')
  if (window.isIframe) {
    openLink(`https://cdn.crezu.net/iframe/v2/offers?sub1=${leadId}&sub2=feed&country=${state.additionalParams.country}`)
    return
  }

  const hostname = window.location.hostname
  const { getFeedData } = useWeightSplitter()
  let prefix = ''
  let { sub2, feedURL, expFlow } = getFeedData(hostname)
  feedURL = feedURL || window.customFeedURL || localStorage.getItem('customFeedURL') || '/offers'
  const querySeparator = feedURL.includes('?') ? '&' : '?'
  expFlow = expFlow || state.additionalParams.exp_flow
  if (+state.additionalParams.country === 10 && localStorage.getItem('lang') === 'en') {
    prefix = '/en'
  }
  if (+state.additionalParams.country === 8 && localStorage.getItem('lang') === 'kz') {
    prefix = '/kz'
  }

  const locale = localStorage.getItem('locale')
  if (hostname === 'loanfinder24.com' && locale) prefix = `/${locale}`
  const finalURL = `${prefix}${feedURL}${querySeparator}sub1=${leadId}&sub2=${sub2}${
    expFlow ? `&exp_flow=${expFlow}` : ''
  }`
  const redirectThroughFingerprint = `https://crezu.net:8002/session` +
    `?domain=${hostname}` +
    `&country_id=${state.additionalParams.country}` +
    `&lead_id=${leadId}` +
    `&type=1` +
    `&method=redirect` +
    `&pq=${finalURL}`
  openLink(redirectThroughFingerprint)
  setTimeout(() => {
    console.log('trigger reserved redirect after 5s')
    openLink(redirectThroughFingerprint)
  }, 5000)
}

export const prepareManualProcess = function ({ commit, state }) {
  let adsPos = [2, 8]
  if (window.innerWidth < 820) {
    adsPos = [3, 9]
  }
  let APIOffers = []
  let APINames = []
  for (let i in state.hardcoreAPILenders) {
    if (state.availableAPILenders.indexOf(+i) > -1 && state.excludedLenders.indexOf(+i) === -1) {
      APINames.push(state.hardcoreAPILenders[i].name)
      APIOffers.push({ ...{ lender_id: +i }, ...state.hardcoreAPILenders[i] })
    }
  }
  APIOffers = APIOffers.sort((a, b) => {
    return a.pos - b.pos
  })

  let nonAPIOffers = []
  for (let i in state.offers) {
    const temp = state.offers[i]
    // temp.link = state.offers[i].link.replace('{LEAD_ID}', state.additionalParams.lead_id).replace('&sub2=feed', '&sub2=feed-manual')
    temp.link = state.offers[i].link.replace('sub1={LEAD_ID}&sub2=feed', `sub1=${state.additionalParams.lead_id}&sub2=feed-manual`)
    temp.type = 'non-API'
    if (APINames.indexOf(temp.name) === -1) {
      // push only NON api. If we have already API - we show only API
      nonAPIOffers.push(temp)
    }
  }

  const orderedLenders = []
  let counter = 0
  while (counter < 20) {
    for (const j in APIOffers) {
      if (counter === APIOffers[j].pos) {
        orderedLenders.push(APIOffers[j])
        counter += 1
      }
    }
    if (nonAPIOffers.length) {
      orderedLenders.push(nonAPIOffers[0])
      nonAPIOffers.shift()
    }
    counter += 1
  }

  const orderedLendersWithAds = []
  for (const i in orderedLenders) {
    orderedLendersWithAds.push(orderedLenders[i])
    if (+i === adsPos[0]) orderedLendersWithAds.push({ ...{ type: 'adsense' }, ...state.mxOffersAds[0] })
    if (+i === adsPos[1]) orderedLendersWithAds.push({ ...{ type: 'adsense' }, ...state.mxOffersAds[1] })
  }
  orderedLendersWithAds.push({ ...{ type: 'adsense' }, ...state.mxOffersAds[2] })

  commit('CHANGE_MANUAL_PROCESS_OFFERS', orderedLendersWithAds)
  const pushAds = () => {
    try {
      // eslint-disable-next-line no-undef
      (adsbygoogle = window.adsbygoogle || []).push({})
    } catch (e) {
      console.log(e)
    }
  }
  setTimeout(x => {
    pushAds()
    setTimeout(x => {
      pushAds()
      setTimeout(x => {
        pushAds()
      }, 500)
    }, 500)
  }, 500)
}



// WEBPACK FOOTER //
// ./src/store/helpers/offers-actions.js